import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import { UtilService } from "../services";
import {
  TestOrder,
  TestOrderTestSelectionSession,
  TestOrderCodeSelectionSession
} from "../models";

export class SetTestOrderICDCodes implements ReduxAction {
  type: string = "SET_TEST_ORDER_ICD_CODES";
  codeSelectionSession: TestOrderCodeSelectionSession;

  constructor(session: TestOrderCodeSelectionSession) {
    this.codeSelectionSession = session;
  }

  get() {
    return {
      SelectedCodes: this.codeSelectionSession.SelectedCodes,
      ICDCodeIds: this.codeSelectionSession.ICDCodeIds
    };
  }
}

export class SetTestOrderTests implements ReduxAction {
  type: string = "SET_TEST_ORDER_TESTS";
  testSelectionSession: TestOrderTestSelectionSession;

  constructor(session: TestOrderTestSelectionSession) {
    this.testSelectionSession = session;
  }

  get() {
    return {
      PanelIds: this.testSelectionSession.SelectedPanelIds,
      SelectedPanels: this.testSelectionSession.SelectedPanels
    };
  }
}

export class SetTestOrderDetails implements ReduxAction {
  type: string = "SET_TEST_ORDER_DETAILS";
  testOrder: TestOrder;

  constructor(updatedTestOrder: TestOrder, private utilService: UtilService) {
    this.testOrder = Object.assign({}, this.testOrder, updatedTestOrder);
    this.testOrder.ReleaseOn = this.utilService.formatDate(
      updatedTestOrder.ReleaseYear,
      updatedTestOrder.ReleaseMonth,
      updatedTestOrder.ReleaseDay
    );
  }

  get() {
    return this.testOrder;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/test-order.actions.ts